import React from "react";
import { Helmet } from 'react-helmet-async';
import Header from "../components/header";
import Footer from "../components/footer";
import blueImage from "../assets/blue.png";
import { FiPackage, FiTrendingUp, FiTool } from "react-icons/fi";

const Home = () => {
    return (
        <div className="animate-fade">
            <Helmet>
                <title>ALKOR Semicon Total Solutions Inc.</title>
                <meta name="description" content="Powering the Future of Semiconductors — ALKOR brings high-quality Korean semiconductor components and supply-chain solutions to the U.S." />
                <meta name="keywords" content="ALKOR, semiconductor, Korea, supply chain, distribution, parts, SK Hynix, Samsung" />
                <link rel="canonical" href="/" />
            </Helmet>
            <Header />

            <div className="mt-[60px] lg:mt-auto relative w-auto h-[95vh] z-[-1] lg:w-auto lg:h-[90vh] lg:overflow-hidden">
                <img src={blueImage} className="w-auto z-0 h-[95vh] landscape:w-full landscape:h-full lg:w-screen lg:h-[90vh] absolute top-0 left-0 object-left-top object-cover opacity-[0.9]" width="2250" height="1500" alt="Blue skyscrapers" />
                <div className="lg:flex lg:flex-col text-grayblack text-center lg:mt-[1em] lg:my-16 p-4">
                    <h1 className="text-[50px] text-white lg:text-grayblack landscape:text-grayblack top-[40%] right-[5%] absolute lg:top-[30%] text-right lg:text-huge lg:right-[10%]">ALKOR Semicon <br />Total Solutions Inc.</h1>
                    <p className="absolute mx-4 lg:mx-auto text-white landscape:text-grayish text-[1em] lg:text-[0.9em] lg:text-[1em] bottom-[10%] right-[5%] lg:text-grayish lg:top-[70%] text-right lg:right-[10%]">Powering the Future of Semiconductors, From Korea to the U.S.</p>
                </div>
            </div>

            <div className="my-[7em] flex flex-col content-center">
                <h2 className="text-center text-[1.2em] lg:text-[2em] mb-[1em]">Connecting the East and West.</h2>
                <p className="text-grayish text-center mx-[2em] lg:mx-[15em] leading-[1.8em]">ALKOR is a trusted distributor of cutting-edge Korean products for semiconductor manufacturing.
                    As leading Korean chipmakers like Samsung and SK Hynix have thrived alongside their advanced domestic suppliers, we bring this proven innovation to the U.S. market.
                    By bridging two distinct cultures, we enable seamless collaboration and access to high-quality Korean semiconductor solutions, driving progress across the industry.</p>
            </div>

            <div className="bg-navy bg-opacity-80 flex flex-col justify-center items-center text-center py-[3em]">
                <div className="flex flex-col lg:flex-row landscape:flex-row justify-evenly lg:my-[2em] content-center landscape:w-full">
                    <div className="text-white mx-[1em] lg:mx-[2em] p-[2em] lg:p-[3em] rounded-xl w-[25em] text-center">
                        <div className="flex justify-center content-center mb-[1em]">
                            <FiPackage size={30} />
                        </div>
                        <h3 className="font-bold text-[1.2em] text-center">Product Distribution & Sourcing</h3>
                        <p className="mt-[0.5em] lg:mt-[1em] text-[1em]">High-quality spare parts, raw materials, sub-fab equipment, and repair services supplied directly to you.</p>
                    </div>

                    <div className="text-white mx-[1em] lg:mx-[2em] p-[2em] lg:p-[3em] rounded-xl w-[25em] text-center">
                        <div className="flex justify-center content-center mb-[1em]">
                            <FiTool size={30} />
                        </div>
                        <h3 className="font-bold text-[1.2em] text-center">Supply Chain & Logistics Support</h3>
                        <p className="mt-[0.5em] lg:mt-[1em] text-[1em]">Shipping, customs, and regulatory compliance handled for you and delivered Just-In-Time (JIT).</p>
                    </div>

                    <div className="text-white mx-[1em] lg:mx-[2em] p-[2em] lg:p-[3em] rounded-xl w-[25em] text-center">
                        <div className="flex justify-center content-center mb-[1em]">
                            <FiTrendingUp size={30} />
                        </div>
                        <h3 className="font-bold text-[1.2em] text-center">Market Expansion & Partnership</h3>
                        <p className="mt-[0.5em] lg:mt-[1em] text-[1em]">Guaranteed personalized assistance in sourcing high-quality Korean components and connecting with Korean technology providers.
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </div >
    );
};

export default Home;




